import Introduction2Container from './introduction2'

export default Introduction2Container